import React, {FC, useMemo} from 'react';
import {Grid} from '@mui/material';
import {STYLES} from './styles';
import {PrimaryCharts} from '../PrimaryCharts';
import {SecondaryCharts} from '../SecondaryCharts';
import {MapValue} from '../MapValue';
import {TabPanel} from '@mui/lab';
import {get} from 'lodash';
import {useStoresContext} from '../../hooks/useStoresContext';
import {useStore} from 'zustand';
import {DashboardTypes} from '../../../../../../shared/types/dashboard.types';
import {RequestsStatusesDashboardCard} from '../RequestsStatusesDashboardCard';

const GRID_CONFIGS = {
  common: {
    grid: [7.6, 4.28, 12],
    orderConfig: {primary: 0, secondary: 1, map: 2},
  },
  part: {
    grid: [12, 12, 12],
    orderConfig: {primary: 0, secondary: 1, map: 2},
  },
} as const;

interface Props {
  serviceType: string;
}

export const DashboardPanel: FC<Props> = ({serviceType}) => {
  const {chartViewStore, dashboardTypeStore} = useStoresContext(serviceType);
  const viewTypeDefault = useStore(chartViewStore, (s) => s.type);
  const gridConfiguration = useMemo(() => get(GRID_CONFIGS, viewTypeDefault), [viewTypeDefault]);
  const {dashboardType} = useStore(dashboardTypeStore);

  return (
    <TabPanel sx={{p: 0}} value={serviceType}>
      {dashboardType === DashboardTypes.REQUESTS_MOVE && (
        <Grid sx={STYLES.grid} container>
          {[
            {
              Component: PrimaryCharts,
              gridSize: gridConfiguration.grid[0],
              order: gridConfiguration.orderConfig.primary,
            },
            {
              Component: SecondaryCharts,
              gridSize: gridConfiguration.grid[1],
              order: gridConfiguration.orderConfig.secondary,
            },
            {
              Component: MapValue,
              gridSize: gridConfiguration.grid[2],
              order: gridConfiguration.orderConfig.map,
            },
          ].map(({Component, gridSize, order}, i) => (
            <Grid
              key={i}
              item
              xs={gridSize}
              sx={{
                ...STYLES.item,
                order,
              }}
            >
              <Component serviceType={serviceType} />
            </Grid>
          ))}
        </Grid>
      )}
      {dashboardType === DashboardTypes.REQUESTS_STATUSES && (
        <Grid
          item
          xs={12}
          sx={{
            ...STYLES.item,
          }}
        >
          <RequestsStatusesDashboardCard serviceType={serviceType} />
        </Grid>
      )}
    </TabPanel>
  );
};
